var map = {
	"./Caso10_Isquemia.png": 1857,
	"./Caso10_Trombosis.png": 949,
	"./Caso11_InfartoIsquemico.png": 1926,
	"./Caso12_Fractura.png": 3775,
	"./Caso13_HombreCamilla.png": 4428,
	"./Caso13_RX.png": 6820,
	"./Caso14_MadreHijo.png": 8578,
	"./Caso14_MamaMani.png": 430,
	"./Caso14_RXCuerpoExtraño.png": 9789,
	"./Caso15_ApendicitisAguda.png": 3971,
	"./Caso15_Nina11.png": 7746,
	"./Caso16_EcoAbdominalColedocolitiasis.png": 3259,
	"./Caso16_SraNancy.png": 1590,
	"./Caso17_AlternativasGraficas.png": 7876,
	"./Caso17_Rinon.png": 8200,
	"./Caso17_RxCorrecta.png": 4687,
	"./Caso17_TC_Sin_Contraste.png": 4000,
	"./Caso18_OpacidadesAlveolares.png": 3902,
	"./Caso19_HombreColonDistendido.png": 8563,
	"./Caso19_Obstruccion_intestinal.png": 6933,
	"./Caso1_1_NMTX_a_tension.jpg": 3813,
	"./Caso1_2_Tubo_drenaje_NMTX.jpg": 8520,
	"./Caso20_DesplazamientoDorsal.png": 8111,
	"./Caso20_MujerRadiogradia.png": 8696,
	"./Caso21_HiperdensaEnTrayecto.png": 9602,
	"./Caso21_TC_ConContraste.png": 2118,
	"./Caso22_BienTomada.png": 5104,
	"./Caso24.png": 7875,
	"./Caso24_Hiperdensidad.png": 6336,
	"./Caso24_MujerPreocupada.png": 6213,
	"./Caso2_1_RX_Ap_Lat.jpg": 7698,
	"./Caso2_2_TAC_Cerebro.jpg": 4874,
	"./Caso2_3_Calcificacion.jpg": 4592,
	"./Caso3_1_RX_Neumonia.jpg": 2722,
	"./Caso3_2_Rx_Tubo_monobronquial.jpg": 6634,
	"./Caso5_Eco_Fast.jpg": 1073,
	"./Caso6_RX_abd_simple_cDibujo.jpeg": 6491,
	"./Caso7_RX_AP_Hombro.jpg": 8893,
	"./Caso7_RX_Lateral_hombro.jpg": 2781,
	"./Caso8_RX_AP_AbdomenEnBipedestacion.jpg": 4314,
	"./Caso9_SailSign.png": 7589,
	"./Logo.png": 906,
	"./Repaso_ALARA.jpg": 1069,
	"./Repaso_Preg11.jpg": 8548,
	"./Repaso_Preg12.jpg": 179,
	"./Repaso_Preg14_RXHuesos.jpg": 7267,
	"./Repaso_Preg7.png": 1931,
	"./Repaso_RXMano.jpg": 7905,
	"./Rx, no ve diafragma. Real.jpg": 8703,
	"./enfermera.jpg": 1098,
	"./escudo_udec.png": 5430,
	"./estudioso.jpg": 7678,
	"./fondo.png": 1821,
	"./fondo_old.png": 6411,
	"./image.png": 7816,
	"./interna.jpg": 7054,
	"./placeholder.png": 2016,
	"./tens_hombre.jpg": 1201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3487;